import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBQantLogotype = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 756,
	height: 183,
	viewBox: "0 0 756 183",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M756.001 47.9388V9.85547H597.139V47.9388H657.757V182.902H695.382V47.9388H756.001Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M562.082 9.85547V163.86C562.082 164.135 562.082 164.41 562.061 164.685C561.643 174.777 553.512 182.712 543.646 182.902H533.8C530.519 182.902 527.321 182.034 524.499 180.405C524.499 180.405 524.485 180.398 524.457 180.384C521.969 178.967 519.816 176.957 518.186 174.46H518.165L453.387 76.9033V182.902H415.762V28.9183C415.762 28.6433 415.762 28.3682 415.783 28.072C416.201 17.853 424.52 9.85547 434.532 9.85547H444.691C447.785 9.91894 450.753 10.7864 453.387 12.2886C455.937 13.7273 458.153 15.7795 459.783 18.2973H459.804L524.457 115.664L524.499 115.727V9.85547H562.082Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.527 161.745H340.241L348.268 182.902H388.736L324.146 21.1324C321.178 14.4043 314.531 9.85547 306.985 9.85547H296.784C289.259 9.85547 282.591 14.4043 279.602 21.1112L215.012 182.902H255.501L263.527 161.745ZM301.884 60.6121L327.469 128.062H276.299L301.884 60.6121Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.454 140.163C158.699 135.085 149.46 132.144 139.531 132.123C130.689 132.081 122.37 134.366 115.158 138.428C107.759 142.511 99.272 144.796 90.2419 144.796C87.4409 144.796 84.6818 144.563 81.9853 144.14C57.0481 140.142 37.9846 118.286 37.9846 91.9027C37.9846 62.7054 61.375 39.0091 90.2419 39.0091C119.109 39.0091 142.499 62.7054 142.499 91.9027C142.499 99.4347 140.952 106.607 138.131 113.081C138.549 113.06 138.967 113.06 139.385 113.06C152.303 113.06 164.405 116.678 174.752 122.941C178.243 113.25 180.124 102.799 180.124 91.9027C180.124 41.675 139.886 0.925781 90.2419 0.925781C40.5975 0.925781 0.359375 41.675 0.359375 91.9027C0.359375 135.275 30.3342 171.539 70.4469 180.658C76.4878 182.033 83.8038 182.795 90.2419 182.88C105.752 182.88 120.342 178.902 133.093 171.899C134.87 170.947 137.253 170.185 139.406 170.206C146.324 170.227 151.926 175.898 151.926 182.88H189.552C189.552 164.938 180.354 149.176 166.454 140.163Z",
			fill: "black"
		})
	]
});
export default SvgBQantLogotype;
